import gsap from "gsap";
export default class VideoPlayerBackground {
    constructor() {
        this.initElements();
        setTimeout(() => {
            this.initAnimation();
        }, 10);
    }

    initElements() {
        this.elements = {
            'layer1': document.getElementById('player-bg-layer-1'),
            'layer1-1': document.getElementById('player-bg-layer-1-1'),
            'layer2': document.getElementById('player-bg-layer-2'),
            'layer2-1': document.getElementById('player-bg-layer-2-1'),
            'layer3': document.getElementById('player-bg-layer-3'),
            'layer3-1': document.getElementById('player-bg-layer-3-1'),
            'layer4': document.getElementById('player-bg-layer-4'),
            'layer4-1': document.getElementById('player-bg-layer-4-1'),
        }

        gsap.set(this.elements['layer4'], {
            transformOrigin: '266px -150px',
            svgOrigin: '266px -150px',
            rotate: '5.36deg'
        });

        gsap.set(this.elements['layer1-1'], {
            transformOrigin: '50% 50%',
            svgOrigin: '50% 50%',
        });

        gsap.set(this.elements['layer2-1'], {
            transformOrigin: '50% 50%',
            svgOrigin: '50% 50%',
        });

        gsap.set(this.elements['layer3-1'], {
            transformOrigin: '50% 50%',
            svgOrigin: '50% 50%',
        });
    }

    initAnimation() {
        const totalDuration = 90;

        this.timeline = gsap.timeline({
            repeat: -1,
        })
        .to(this.elements['layer4'], {
            duration: totalDuration,
            rotation: "-=360",
            ease: 'none'
        })
            .to(this.elements['layer1-1'], {
                duration: totalDuration / 4,
                rotate: "-30",
                ease: 'none'
            }, 0)
            .to(this.elements['layer1-1'], {
                duration: totalDuration / 4,
                rotate: "0",
                ease: 'none'
            }, totalDuration / 4)
            .to(this.elements['layer1-1'], {
                duration: totalDuration / 4,
                rotate: "30",
                ease: 'none'
            }, totalDuration / 2)
            .to(this.elements['layer1-1'], {
                duration: totalDuration / 4,
                rotate: "0",
                ease: 'none'
            }, totalDuration / 4 * 3)

            .to(this.elements['layer2-1'], {
                duration: totalDuration / 4,
                rotate: "-20",
                ease: 'none'
            }, 0)
            .to(this.elements['layer2-1'], {
                duration: totalDuration / 4,
                rotate: "0",
                ease: 'none'
            }, totalDuration / 4)
            .to(this.elements['layer2-1'], {
                duration: totalDuration / 4,
                rotate: "20",
                ease: 'none'
            }, totalDuration / 2)
            .to(this.elements['layer2-1'], {
                duration: totalDuration / 4,
                rotate: "0",
                ease: 'none'
            }, totalDuration / 4 * 3)

            .to(this.elements['layer3-1'], {
                duration: totalDuration / 4,
                rotate: "30",
                y: "+=50%",
                ease: 'none'
            }, 0)
            .to(this.elements['layer3-1'], {
                duration: totalDuration / 4,
                y: "-=50%",
                rotate: "0",
                ease: 'none'
            }, totalDuration / 4)
            .to(this.elements['layer3-1'], {
                duration: totalDuration / 4,
                y: "-=50%",
                rotate: "-30",
                ease: 'none'
            }, totalDuration / 2)
            .to(this.elements['layer3-1'], {
                duration: totalDuration / 4,
                y: "+=50%",
                rotate: "0",
                ease: 'none'
            }, totalDuration / 4 * 3)

        .to(this.elements['layer4-1'], {
            duration: totalDuration / 2,
            x: "2000",
            y: "1000",
            ease: 'none'
        },0)
        .to(this.elements['layer4-1'], {
            duration: totalDuration / 2,
            x: "0",
            y: "0",
            ease: 'none'
        }, totalDuration / 2);
    }

    pause() {
        this.timeline.pause();
    }

    resume() {
        this.timeline.resume();
    }
}
